import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const Main = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  overflow: auto;
  height: calc(100% - 15px);
  margin: 15px 15px 0px;
  box-shadow: 0px 4px 3px ${ColorSF2.transparentShadow};

  ${props =>
    props.fullscreen &&
    `
  width: 100vw;
  height: 100%;
  padding: 15px;
`}
`;

export const Block = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Content = styled.div`
  height: calc(100% - 98px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media (max-width: 830px), (max-height: 530px) {
    height: calc(100% - 60px);
  }
`;

export const ListsWrapper = styled.div`
  height: ${props =>
    (props.searchBoxHeight && `calc(100% - ${props.searchBoxHeight}px)`) ||
    '100%'};
`;
